import React from 'react';
import { connect } from '@souche-f2e/muji';
import { Table } from 'antd';
import preStyle from '../_style/preView.less';
import { setKey } from '@/shared/functions';
const mapStateToProps = (rootState, ownProps) => {
    return {
        report: rootState.reportCreate,
    };
};
const Placeholder = () => {
    return (<div className={preStyle.holder}>
      <img src="https://assets.souche.com/assets/sccimg/common/common_background_nocar.png" alt="暂无预览内容" width="96" height="96"/>
      <div className={preStyle.holder_title}>暂无预览内容</div>
      <div className={preStyle.holder_desc}>请在右侧设置表格内容</div>
    </div>);
};
class PreView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExtend: true,
        };
    }
    reRender(isShowAll) {
        this.setState({
            isExtend: isShowAll,
        });
    }
    render() {
        const { showPreView } = this.props.report;
        const { isExtend } = this.state;
        return (<div className={preStyle.window}>
        <div className={preStyle.title}>预览报表</div>
        <div className={preStyle.view_window}>
          {showPreView ? <PreTable isExtend={isExtend}/> : <Placeholder />}
        </div>
      </div>);
    }
}
class PreTableComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemWidth: 220,
        };
        this.dealColumns = this.dealColumns.bind(this);
    }
    componentDidMount() {
        window.addEventListener('resize', () => {
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', () => {
        });
    }
    dealColumns() {
        const { isExtend } = this.props;
        const fixedKey = ['startDt', 'sessNum', 'sessName', 'serialNumber', 'buyerName'];
        const { itemWidth = 220 } = this.state;
        const $bodyWidth = document.getElementsByTagName('body')[0].clientWidth;
        const tableWidth = isExtend ? $bodyWidth - 846 : $bodyWidth - 228;
        const { preViewTableColumns } = this.props.report;
        const columnsLength = preViewTableColumns.length;
        if (columnsLength * itemWidth < tableWidth) {
            return preViewTableColumns.map((item) => {
                return Object.assign(Object.assign({}, item), { width: itemWidth });
            });
        }
        return preViewTableColumns.map((item) => {
            const key = item.dataIndex;
            const needFixed = fixedKey.includes(key);
            return Object.assign(Object.assign({}, item), { fixed: needFixed ? 'left' : undefined, width: itemWidth });
        });
    }
    componentDidUpdate() {
        const { listDisplayItems } = this.props.report;
        const scrollTable = document.getElementsByClassName('ant-table-body')[0];
        const scrollTableHead = document.getElementsByClassName('ant-table-header')[0];
        if (scrollTableHead) {
            const left = scrollTableHead.scrollLeft;
            const leftNum = listDisplayItems.length * 220;
            setTimeout(() => {
                left !== leftNum && (scrollTableHead.scrollLeft = leftNum);
            }, 500);
        }
        if (scrollTable) {
            const left = scrollTable.scrollLeft;
            const top = scrollTable.scrollTop;
            const leftNum = listDisplayItems.length * 220;
            setTimeout(() => {
                left !== leftNum && (scrollTable.scrollLeft = leftNum);
                top !== 0 && (scrollTable.scrollTop = 0);
            }, 500);
        }
    }
    render() {
        const { itemWidth = 220 } = this.state;
        const { reportFormName, preViewTableData, } = this.props.report;
        const tableColums = this.dealColumns();
        const tableScrollX = tableColums[0].fixed ? `${tableColums.length * itemWidth}px` : undefined;
        const $tableHeight = document.getElementsByTagName('body')[0].clientHeight;
        const fixedHeight = $tableHeight - 370;
        return (<div style={{
            width: '100%',
        }}>
        <div className={preStyle.report_title}>{reportFormName}</div>
        <Table className={'pre_view_table'} onRow={(record) => {
            return {
                className: record.isOver ? preStyle.is_over : undefined,
            };
        }} bordered={true} scroll={{
            x: tableScrollX,
            y: `${fixedHeight}px`,
        }} columns={tableColums} dataSource={setKey(preViewTableData)} pagination={false}/>
      </div>);
    }
}
export const PreTable = connect(mapStateToProps)(PreTableComponent);
export default connect(mapStateToProps, null, null, { forwardRef: true })(PreView);
